// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportSavedModal_root__1WZdG","title":"ReportSavedModal_title__XR5sN","description":"ReportSavedModal_description__1S53V","footer":"ReportSavedModal_footer__qSCXx"};